import { Stripe } from '@stripe/stripe-js';

// Shows the bank's approval popup (3DS) for the first payment of a membership-style subscription.
// Returns an error message, or '' when the bank approved it.
// (The Payments page has the same step inline for the guest membership.)
export const approveMembershipPayment = async (
    stripePromise: Promise<Stripe | null> | null,
    clientSecret: string,
): Promise<string> => {
    const stripeClient = stripePromise ? await stripePromise : null;
    if (!stripeClient) return 'Card payments are not available right now. Please try again later.';
    try {
        const result = await stripeClient.confirmCardPayment(clientSecret);
        if (result.error) return result.error.message || 'Your bank did not approve this payment.';
        return '';
    } catch (error) {
        return error instanceof Error ? error.message : 'Your bank did not approve this payment.';
    }
};
